import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';

import './index.css';

export class BannerComponent extends React.Component {
  render() {
    const {
      className,
      children,
      message,
      leftIcon,
      isError,
      theme,
      rightIcon,
    } = this.props;
    const classes = classnames(
      'banner',
      className,
      theme && theme.map(css => `banner--${css}`).join(' ')
    );

    if (!message && !children) {
      return null;
    }

    return (
      <div className={classes}>
        {!isError && <span className="banner__checkmark" role="presentation" />}
        {leftIcon}
        {message}
        {rightIcon}
        {children}
      </div>
    );
  }
}

BannerComponent.propTypes = {
  className: PropTypes.string,
  duration: PropTypes.number,
  id: PropTypes.string,
  // use children to use react elements
  children: PropTypes.element,
  message: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
    PropTypes.element,
  ]),
  isError: PropTypes.bool,
  theme: PropTypes.array,
  leftIcon: PropTypes.node,
  rightIcon: PropTypes.node,
};

BannerComponent.defaultProps = {
  isError: true,
  message: '',
};

const mapState = ({ banner }, { id }) => {
  return {
    message: banner[id].message,
    isError: banner[id].isError,
  };
};

export default connect(mapState)(BannerComponent);



// WEBPACK FOOTER //
// ./src/common/components/Banner/index.js